import { faFlagCheckered, faPlay, faProjectDiagram } from '@fortawesome/free-solid-svg-icons'
import { createSlice } from '@reduxjs/toolkit'

const data = createSlice({
    name: 'data',//Данные для виджетов 
    initialState: {
        boardType: [{ id: 1, name: 'Проект/ожидание', icon: faProjectDiagram, description: "Для задач еще не взятых в работу. Например: проекты задач, лист ожидания..." }
            , { id: 2, name: 'В работе', icon: faPlay, description: 'Задачи на доске взяты работу.' }
            , { id: 3, name: 'Завершена', icon: faFlagCheckered, description: 'По задачам завершены работы. ' }
        ], //Типы доски

    },
    reducers: {

    }
})

export const { } = data.actions
export default data.reducer